// extracted by mini-css-extract-plugin
export default {"container":"ChipView_container__T34GK","titleText":"ChipView_titleText__ikYA+"};